import { StockMovementCoreResponse, StockMovementPublicResponse } from 'skladon-types';

import { GridOutput, mapToCoreGridInput, mapToPublicGridOutput, ToCoreGridInput } from '../grid';

import { convertObjectPropertiesToCamelCase } from './common';

const omitColumns = ['ESHOP_KEY', 'PRODUCT_ID'];

export class StockMovementsMapper {
    static fromCore(input: StockMovementCoreResponse): StockMovementPublicResponse {
        return convertObjectPropertiesToCamelCase(input, ['ESHOP_KEY', 'PRODUCT_ID']);
    }

    static toCoreGrid(input: ToCoreGridInput) {
        return mapToCoreGridInput(input, omitColumns);
    }

    static fromCoreGrid(input: GridOutput<StockMovementCoreResponse>) {
        return mapToPublicGridOutput(input, omitColumns);
    }
}
